<template>
  <div class="container">
    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center fullscreen :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <p style="margin-bottom: 30px;">请输入查询密码</p>
      <el-input v-model="password" placeholder="请输入查询密码" @keyup.enter.native="search" clearable
        @clear="search" type="password"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="authPassword">确 定</el-button>
      </span>
    </el-dialog>
    <div style="padding: 30px 0;display: flex; align-items: center;justify-content: flex-end;">
      <el-select v-model="exam_id" placeholder="请选择考试">
        <el-option label="全部考试" value=""></el-option>
        <el-option v-for="(item, index) of examList" :key="index" :label="item.title" :value="item.id"></el-option>
      </el-select>
      <el-input style="margin-left: 20px;" v-model="phone" placeholder="请输入考生手机号" @keyup.enter.native="search" clearable
        @clear="search"></el-input>
      <el-button type="primary" @click="search" style="margin-left: 20px;">搜索</el-button>
      <el-button type="success" @click="dialogFormVisible = true" style="margin-left: 20px;">添加用户</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%" width="280">
      <el-table-column prop="phone" label="手机号" width="120" align="center">
      </el-table-column>
      <el-table-column prop="student_name" label="姓名" width="80" align="center">
      </el-table-column>
      <el-table-column prop="title" label="所属考试" width="360" align="center">
      </el-table-column>
      <el-table-column prop="post_exam" label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.post_exam == 1 ? 'success' : 'primary'" disable-transitions>{{ scope.row.post_exam == 1
            ? '已交卷' : '未交卷' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="post_time" label="交卷时间" width="180" align="center">
      </el-table-column>
      <el-table-column prop="end_score" label="总成绩" width="100" align="center">
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button @click="printPdf(scope.row)" type="text" size="small">导出报告</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-popconfirm title="确认要重置该用户的考试时间吗？" @confirm="changeBeginTime(scope.row)">
            <el-button slot="reference" type="text" size="small">重置时间</el-button>
          </el-popconfirm>
          <el-divider direction="vertical"></el-divider>
          <el-popconfirm title="确认要删除该用户吗？" @confirm="delUser(scope.row)">
            <el-button slot="reference" type="text" size="small">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div style="padding: 30px 0;display: flex; align-items: center;justify-content: flex-end;">
      <el-pagination background layout="prev, pager, next" :total="count" @size-change="userList"
        @current-change="userList" :current-page.sync="page" :page-size.sync="page_size">
      </el-pagination>
    </div>
    <el-dialog title="添加用户" :visible.sync="dialogFormVisible" :width="dialogWidth">
      <el-form>
        <el-form-item label="手机号" :label-width="formLabelWidth">
          <el-input maxlength="11" type="number" v-model="form.phone" autocomplete="off" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="form.student_name" autocomplete="off" style="width: 50%;"></el-input>
        </el-form-item>
        <el-form-item label="所属考试" :label-width="formLabelWidth">
          <el-select v-model="form.exam_id" placeholder="请选择考试">
            <el-option v-for="(item, index) of examList" :key="index" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUser">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<style>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px;
}
</style>

<script>
export default {
  computed: {
    dialogWidth() {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      return isMobile ? '90%' : '50%';
    },
  },
  data() {
    return {
      p:'',
      exam_id: '',
      phone: '',
      page: 1,
      page_size: 15,
      tableData: [],
      count: 0,
      centerDialogVisible:true,
      dialogFormVisible: false,
      formLabelWidth: '100px',
      examList: [],
      form: {
        phone: '',
        exam_id: '',
        student_name: ''
      },
      password:''
    }
  },
  created() {
    this.getExamList();
    let p = localStorage.getItem('VhPlhVSxwFUO');
    if(p){
      this.p = p;
      this.centerDialogVisible = false;
      this.userList();
    }else{
      this.centerDialogVisible = true;
    }
  },
  methods: {
    search() {
      this.page = 1;
      this.userList();
    },
    authPassword(){
      let params = {
        "p":this.password
       }
      this.$request.post('sike.php/admin/adminLogin', params).then((res) => {
        if (res.code == 200) {
          localStorage.setItem('VhPlhVSxwFUO',res.data);
          this.centerDialogVisible = false;
          this.p = res.data;
          this.userList();
        } else {
          this.$message.error(res.message);
        }
      })
    },
    // 删除用户
    delUser(row) {
      this.$request.post('sike.php/admin/delUser', { user_id: row.id }).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.userList();
        } else {
          this.$message.error(res.message);
        }
      })
    },
    // 添加用户
    addUser() {
      this.$request.post('sike.php/admin/addUser', this.form).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.phone = this.form.phone;
          this.dialogFormVisible = false;
          this.search();
        } else {
          this.$message.error(res.message);
        }
      })
    },
    // 获取考试列表
    getExamList() {
      // admin/examList
      this.$request.get('sike.php/admin/examList').then((res) => {
        if (res.code == 200) {
          this.examList = res.data;
        }
      })
    },
    // 重置时间
    changeBeginTime(row) {
      let params = {
        user_id: row.id
      }
      this.$request.post('sike.php/admin/changeBeginTime', params).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        } else {
          this.$message.error(res.message);
        }
      })
    },
    printPdf(row) {
      window.open('https://inner.exam.thinkersike.com/#/Print?phone=' + row.phone)
    },
    userList() {
      let params = {
        "page": this.page,
        "page_size": this.page_size,
        "phone": this.phone,
        "exam_id": this.exam_id,
        "nxPnhKtoxrSx":this.p
        // "student_name": "",
        // "post_exam": ""
      }
      this.$request.post('sike.php/admin/userList', params).then((res) => {
        if (res.code == 200) {
          let { count, list } = res.data;
          this.tableData = list;
          this.count = count;
        }
        if (res.code == 202) {
          this.centerDialogVisible = true;
        }
      })
    }
  }
};
</script>